$(function () {
  let section = $('#modalCalendarioReserva')
  if (section.get(0) == null) {
    return
  }

  let vueAppReserva;

  let terrazaJson = {}
  let fechasPreciosEspecial = []
  let callbackReserva

  window.CalendarioReservaVue = vueAppReserva =  new Vue({
    el: section.get(0),
    data: {
      clienteNombre: null,
      clienteEmail: null,
      reservaNotas: null,

      servicios: [],

      tiposEventosListado: [],
      tipoEvento: null,

      terraza: {},
      precios: [],
      precio: null,
      preciosDisponibles: [],

      diasSemanaHabilitados: [],
      personasListado: [],
      personas: null,

      horaInicio: null,
      horasDeInicio: [],
      horaFin: null,
      horasDeFin: [],
      fecha: null,
      langFecha: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: true,
      },
      disabledDates: function _default(date) {
        const hoy = new Date();
        const hoyDespues6Meses = new Date(hoy);
        hoyDespues6Meses.setMonth(hoy.getMonth() + 6);

        if(date < hoy || date > hoyDespues6Meses){
          return true
        }

        let dia = date.getDay();
        if(dia == 0){
          dia = 7
        }
        if(!vueAppReserva.diasSemanaHabilitados.includes(dia)){
          return true
        }

        return date < new Date();
      },
      terrazaId: null,

      showServicios: false
    },
    mounted() {

    },
    methods: {
      agregarReserva(terrazaId, fecha, callback = null){
        callbackReserva = callback
        this.terrazaId = terrazaId
        this.showServicios = false
        this.clienteNombre = null
        this.clienteEmail = null
        this.reservaNotas = null
        this.personas = null
        this.tipoEvento = null
        this.getTerrazaDatos(fecha)
      },
      actualizarDia(date){
        let fechaFormato = null
        if(date == null){
          this.preciosDisponibles = []
        }
        else{
          let dia = date.getDay();
          if(dia == 0){
            dia = 7
          }
          this.preciosDisponibles = this.precios.filter(item => {
            return item.dia_semana == dia
          })
        }

        if(this.preciosDisponibles.length > 0){
          this.precio = Object.assign({}, this.preciosDisponibles[0])

          let precioEspecial = fechasPreciosEspecial.find(item => item.fecha == fechaFormato)
          if(precioEspecial != null){
            if(precioEspecial.precio != null){
              this.precio.precio = precioEspecial.precio
            }
            if(precioEspecial.precio_hora_extra != null){
              this.precio.precio_hora_extra = precioEspecial.precio_hora_extra
            }
          }
        }
        else{
          this.precio = null
        }
        this.horaInicio = null
        this.horasExtras = null
        // this.horasOpciones = []
        this.actualizarHoraInicioDisponibles()
      },
      actualizarHoraInicioDisponibles(){
        this.horasDeInicio = []
        this.horasDeFin = []
        this.horaFin = null

        if(this.preciosDisponibles.length > 0) {
          for(let i in this.preciosDisponibles){
            let precioListado = this.preciosDisponibles[i]

            let horaInicio = dayjs(this.fechaFormato + " " + precioListado.hora_inicio, "YYYY-MM-DD HH:mm");
            let maxHoraInicio = dayjs(this.fechaFormato + " " + precioListado.hora_fin, "YYYY-MM-DD HH:mm");
            maxHoraInicio = maxHoraInicio.add(this.terraza.min_horas * -1, 'hours');

            if(horaInicio.isAfter(maxHoraInicio)){
              maxHoraInicio = maxHoraInicio.add(1, "days")
            }

            do{
              this.horasDeInicio.push({
                code: horaInicio.format("HH:mm:ss"),
                label: horaInicio.format("HH:mm")
              })
              horaInicio = horaInicio.add(30, "minutes")
            }
            while (maxHoraInicio.isAfter(horaInicio))

            this.horasDeInicio.push({
              code: horaInicio.format("HH:mm:ss"),
              label: horaInicio.format("HH:mm")
            })
          }
        }
      },
      enviarReserva(){
        if(this.clienteEmail != null && this.clienteEmail.length > 0
        && !ValidarEmail(this.clienteEmail)){
          Alert("Ingresa un correo electrónico válido", "info")
          return
        }
        if(this.personas == null){
          Alert("Selecciona personas", "info")
          return
        }
        if(this.tipoEvento == null){
          Alert("Selecciona tipo de evento", "info")
          return
        }
        if(this.fecha == null){
          Alert("Selecciona fecha", "info")
          return
        }
        if(this.horaInicio == null){
          Alert("Selecciona hora de inicio", "info")
          return
        }
        if(this.horaFin == null){
          Alert("Selecciona hora de fin", "info")
          return
        }

        if(this.servicios.length > 0 && !this.showServicios){
          this.showServicios = true
          return;
        }

        let servicios = this.servicios.filter((servicio) => {
          return servicio.cantidad != null && `${servicio.cantidad}`.length > 0
        }).map((servicio) => {
          return JSON.stringify({
            servicio_id: servicio.id,
            cantidad: servicio.cantidad
          })
        })

        let data = {
          terraza_id: this.terrazaId,
          tipo_evento_id: this.tipoEvento.code,
          fecha: this.fechaFormato,
          hora_inicio: this.horaInicio.code,
          hora_fin: this.horaFin.code,
          cliente_nombre: this.clienteNombre,
          cliente_correo: this.clienteEmail,
          mensaje: this.reservaNotas,
          personas: this.personas.code,
          servicios: servicios,
        }

        $("#btnReservaSiguiente").loader("show")
        axios
          .post('/anfitrion/calendario/agregar-reserva', data)
          .then((respuesta) => {
            $("#btnReservaSiguiente").loader("hide")
            if (respuesta.data.error) {
              Alert(respuesta.data.error, "info")
              return
            }

            Alert("Evento agregado", "success")

            if(callbackReserva != null){
              callbackReserva(respuesta.data.reservacion)
            }

          })
          .catch((error) => {
            ReportErrorLog(error)
            console.error(error)
            $("#btnReservaSiguiente").loader("hide")
            Alert("Ocurrió un error inesperado", "info")
          })
      },

      actualizarHoraInicio(hora, horaFinDefecto = null){
        this.horasDeFin = []
        if(hora == null){
          this.horaFin = null
          return
        }
        let fechaFormato = this.fechaFormato

        let precioEspecial = fechasPreciosEspecial.find(item => item.fecha == fechaFormato)

        let fecha = dayjs(this.fechaFormato + " " +hora.code, "YYYY-MM-DD HH:mm:ss").toDate();
        let precioEncontrado = null
        for(let index in this.preciosDisponibles){
          let precio = Object.assign({}, this.preciosDisponibles[index])

          if(precioEspecial != null){
            if(precioEspecial.precio != null){
              precio.precio = precioEspecial.precio
            }
            if(precioEspecial.precio_hora_extra != null){
              precio.precio_hora_extra = precioEspecial.precio_hora_extra
            }
          }

          let horaFinArr = precio.hora_fin.split(":")
          horaFinArr[0] = parseInt(horaFinArr[0]) - this.terraza.min_horas

          let fechaInicio = dayjs(this.fechaFormato + " " + precio.hora_inicio, "YYYY-MM-DD HH:mm")
          let fechaFin = dayjs(this.fechaFormato + " " + precio.hora_fin, "YYYY-MM-DD HH:mm")
          fechaFin = fechaFin.add(this.terraza.min_horas * -1, 'hours');
          if (fechaInicio.isAfter(fechaFin)) {
            fechaFin = fechaFin.add(1, 'days');
          }
          fechaInicio = fechaInicio.toDate()
          fechaFin = fechaFin.toDate()

          let horaEncontrada = fecha.valueOf() >= fechaInicio.valueOf()
            && fecha.valueOf() <= fechaFin.valueOf()
          if(horaEncontrada){
            precioEncontrado = precio
            break
          }
        }

        this.precio = precioEncontrado

        let horaInicio = dayjs(this.fechaFormato + " " +hora.code, "YYYY-MM-DD HH:mm:ss")
        let horaFin = dayjs(this.fechaFormato + " " +precioEncontrado.hora_fin, "YYYY-MM-DD HH:mm:ss");
        horaInicio = horaInicio.add(this.terraza.min_horas, 'hours');

        if(horaInicio.isAfter(horaFin)){
          horaFin = horaFin.add(1, "days")
        }

        let horaExtra = 0
        let precioHoraExtra = 0
        if(precioEncontrado.precio_hora_extra > 0){
          precioHoraExtra = precioEncontrado.precio_hora_extra
        }
        let index = 1
        while (horaFin.isAfter(horaInicio)) {
          this.horasDeFin.push({
            code: horaInicio.format("HH:mm:ss"),
            label: horaInicio.format("HH:mm"),
            hora_extra: horaExtra,
            precio_extra: horaExtra * precioHoraExtra
          })
          horaInicio = horaInicio.add(30, "minutes")
          index += 1
          if(index % 2 == 0){
            horaExtra+=1
          }
        }

        this.horasDeFin.push({
          code: horaInicio.format("HH:mm:ss"),
          label: horaInicio.format("HH:mm"),
          hora_extra: horaExtra,
          precio_extra: horaExtra * precioHoraExtra
        })

        if(this.horaFin != null){
          let horaCode = this.horaFin.code
          let findIndex = this.horasDeFin.findIndex(item => item.code == horaCode)
          if(findIndex > -1){
            this.horaFin = this.horasDeFin[findIndex]
          }
          else{
            this.horaFin = null
          }
        }

        if(horaFinDefecto != null){
          let findIndex = this.horasDeFin.findIndex(item => item.code == horaFinDefecto)
          if(findIndex > -1){
            this.horaFin = this.horasDeFin[findIndex]
          }
        }

      },

      getTerrazaDatos(fecha){
        $("#btnReservaSiguiente").loader("show")
        axios
          .get('/terraza-json', {
            params: {
              terraza_id: this.terrazaId,
            },
          })
          .then((respuesta) => {
            $("#btnReservaSiguiente").loader("hide")
            if (respuesta.data.error) {
              Alert(respuesta.data.error, "info")
              return
            }
            terrazaJson = respuesta.data.terraza
            vueAppReserva.terraza = respuesta.data.terraza;
            vueAppReserva.precios = respuesta.data.terraza.precios;
            vueAppReserva.servicios = respuesta.data.terraza.servicios;

            vueAppReserva.tiposEventosListado = respuesta.data.tiposEventos.map((item) => {
              return {
                code: item.id,
                label: item.nombre,
                icono: item.imagen_thumb
              }
            })

            for(let i in respuesta.data.fechasEspeciales){
              let item = respuesta.data.fechasEspeciales[i]
              if(item.precio != null || item.precio_hora_extra != null){
                fechasPreciosEspecial.push(item)
              }
            }

            vueAppReserva.setupConfigTerraza()

            vueAppReserva.fecha = dayjs(fecha).toDate()
            vueAppReserva.actualizarDia(this.fecha)

          })
          .catch((error) => {
            ReportErrorLog(error)
            console.error(error)
            $("#btnReservaSiguiente").loader("hide")
            Alert("Ocurrió un error inesperado", "info")
          })
      },
      setupConfigTerraza(){
        for(let index in this.precios){
          if(!this.diasSemanaHabilitados.includes(this.precios[index].dia_semana)){
            this.diasSemanaHabilitados.push(this.precios[index].dia_semana)
          }
        }
        let minPersonas = terrazaJson.min_personas;
        if(minPersonas == 1){
          this.personasListado.push({
            code: minPersonas,
            label: minPersonas + " persona"
          })
          minPersonas = 5;
        }
        for(let i = minPersonas; i <= terrazaJson.max_personas; i+=5){
          this.personasListado.push({
            code: i,
            label: i + " personas"
          })
        }
        this.personas = this.personasListado[0]

        $('[data-toggle="tooltip"]').tooltip();
      },
      restarServicio(index){
        let cantidad = this.servicios[index].cantidad - 1
        if(isNaN(cantidad)){
          cantidad = 0
        }
        if(cantidad <= 0){
          cantidad = 0
        }

        if(cantidad > 0){
          if(this.servicios[index].cantidad_min != null &&
            cantidad < this.servicios[index].cantidad_min){
            cantidad = this.servicios[index].cantidad_min
          }
          else if(this.servicios[index].cantidad_max != null &&
            cantidad > this.servicios[index].cantidad_max){
            cantidad = this.servicios[index].cantidad_max
          }
        }

        this.servicios[index].cantidad = cantidad
        this.$forceUpdate()
      },

      sumarServicio(index){
        let cantidad = this.servicios[index].cantidad + 1
        if(isNaN(cantidad)){
          cantidad = 1
        }
        if(cantidad < 0){
          cantidad = 0
        }
        if(this.servicios[index].cantidad_min != null &&
          cantidad < this.servicios[index].cantidad_min){
          cantidad = this.servicios[index].cantidad_min
        }
        else if(this.servicios[index].cantidad_max != null &&
          cantidad > this.servicios[index].cantidad_max){
          cantidad = this.servicios[index].cantidad_max
        }
        if(cantidad == 0){
          cantidad = null
        }
        this.servicios[index].cantidad = cantidad
        this.$forceUpdate()
      }
    },
    computed: {
      url: function (){
        let base = "/checkout/agregar-servicios/"
        if(this.terraza.servicios.length == 0){
          base = "/checkout/finalizar/"
        }
        return base + this.terraza.slug + "_" + this.terraza.id;
      },
      fechaFormato: function (){
        if(this.fecha == null){
          return null;
        }
        return dayjs(this.fecha).format('YYYY-MM-DD')
      },
      totalTerraza: function (){
        let total = this.terraza.precio
        if(this.precio != null){
          total = this.precio.precio
        }
        if(this.horaFin != null){
          total += this.horaFin.precio_extra
        }
        return total
      },
    },
  });
});
